import { CheckCircle2, AlertTriangle } from "lucide-react";
import { badEmail } from "@/lib/clientImport";

const SHOW = 5;

const Line = ({ c, i, testid }) => (
  <li className="py-2 border-b border-border last:border-0 min-w-0" data-testid={`${testid}-preview-${i}`}>
    <p className="text-sm font-medium truncate">{c.name}</p>
    <p className="text-xs text-muted-foreground truncate">
      {[c.contact, c.phone].filter(Boolean).join(" · ")}{c.email && (c.contact || c.phone) ? " · " : ""}
      {c.email && <span className={badEmail(c.email) ? "text-destructive line-through" : ""}>{c.email}</span>}
      {!c.contact && !c.phone && !c.email && "No contact details"}
    </p>
    {c.address && <p className="text-xs text-muted-foreground truncate">{c.address}</p>}
  </li>
);

// The first few clients exactly as they'll be saved, plus how many are ready.
export const ImportPreview = ({ imp, testid = "client-import" }) => {
  if (!imp.hasName) {
    return (
      <p className="flex items-start gap-2 rounded-lg bg-destructive/10 text-destructive p-3 text-sm" data-testid={`${testid}-no-name`}>
        <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" /> Pick which column has the client name.
      </p>
    );
  }
  const left = imp.sheet.total - imp.clients.length;
  const bad = imp.clients.filter((c) => badEmail(c.email)).length;
  return (
    <div className="rounded-lg border border-border px-3 pb-1 min-w-0" data-testid={`${testid}-preview`}>
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground pt-3" data-testid={`${testid}-ready`}>
        {imp.clients.length} client{imp.clients.length !== 1 ? "s" : ""} ready{left > 0 ? ` · ${left} row${left !== 1 ? "s" : ""} with no name left out` : ""}
      </p>
      {bad > 0 && <p className="text-xs text-destructive pt-1" data-testid={`${testid}-bad-email-note`}>{bad} email address{bad !== 1 ? "es don't" : " doesn't"} look right and will be left blank.</p>}
      <ul>{imp.clients.slice(0, SHOW).map((c, i) => <Line key={`${c.name}-${i}`} c={c} i={i} testid={testid} />)}</ul>
      {imp.clients.length > SHOW && <p className="text-xs text-muted-foreground pb-2">…and {imp.clients.length - SHOW} more</p>}
    </div>
  );
};

export const ImportResult = ({ r, testid = "client-import" }) => (
  <div className="rounded-lg border border-border p-4 space-y-2 text-sm" data-testid={`${testid}-result`}>
    <p className="flex items-center gap-2 font-medium"><CheckCircle2 className="w-4 h-4 text-emerald-600" />
      <span data-testid={`${testid}-added`}>{r.added} client{r.added !== 1 ? "s" : ""} added{r.depot_name ? ` to ${r.depot_name}` : ""}</span></p>
    {r.skipped > 0 && (
      <p className="text-muted-foreground" data-testid={`${testid}-skipped`}>
        {r.skipped} skipped — already in this depot: <span className="text-foreground">{r.skipped_names.join(", ")}{r.skipped > r.skipped_names.length ? "…" : ""}</span>
      </p>
    )}
    {r.bad_emails > 0 && <p className="text-muted-foreground" data-testid={`${testid}-bad-emails`}>{r.bad_emails} email address{r.bad_emails !== 1 ? "es" : ""} didn&apos;t look right and {r.bad_emails !== 1 ? "were" : "was"} left blank.</p>}
  </div>
);
